module.exports = __webpack_public_path__ + "img/apps (1).95956aaf.png";